import {Accordion} from '@mantine/core';
import React from 'react';
import type {AuditLogSimpleResponse} from 'src/api/ProactApiClient';
import {Description} from 'src/design/atoms/Description';
import {SectionTitle} from 'src/design/atoms/Typography';
import {Paginator} from 'src/design/organisms/Pagination';
import {TableBodyRender} from 'src/design/molecules/TableBodyRender';
import {AuditLogDiff} from './AuditLogDiff';

export interface AuditLogsListProps {
  rows: AuditLogSimpleResponse[];
  totalRecords: number;
  isLoading: boolean;
  currentPage: number;
  onPageChange: (page: number) => void;
  maxPageRows?: number;
}

export const AuditLogsList: React.FC<AuditLogsListProps> = ({
  rows,
  totalRecords,
  isLoading,
  currentPage,
  onPageChange,
  maxPageRows = 10,
}) => {
  const handlePageChange = (_: any, page: number) => {
    onPageChange(page);
  };

  return (
    <>
      {isLoading ? (
        <TableBodyRender isLoading={isLoading} />
      ) : (
        <>
          {rows.length === 0 ? (
            <Description text="No audit data found." />
          ) : (
            <>
              <Accordion>
                {rows.map(row => (
                  <Accordion.Item key={row.id} value={String(row.id)}>
                    <Accordion.Control>
                      <SectionTitle
                        text={`${row.actionType} - ${row.createdAt
                          .toString()
                          .toLongDate()} - ${row.creator?.name}`}
                      />
                    </Accordion.Control>
                    <Accordion.Panel>
                      <AuditLogDiff audit={row} header={<></>} />
                    </Accordion.Panel>
                  </Accordion.Item>
                ))}
              </Accordion>

              <Paginator
                mt={16}
                perPage={maxPageRows}
                currentPage={currentPage}
                totalRecords={totalRecords}
                onChange={handlePageChange}
              />
            </>
          )}
        </>
      )}
    </>
  );
};
